import axios from "axios"

import { useConfigurationStore } from "@/store/configuration.js"

export const logIn = ({ email, password, code, manage_ui_displayed }) => {
  if (code) {
    return axios.post("/api/v2/magic_sessions", { code })
  }
  return axios.post("/api/v1/sessions", { email, password, manage_ui_displayed })
}

export const refresh = ({ secret_id, secret, refresh_token }) =>
  axios.post(`/api/v1/sessions/${secret_id}/refresh`, {
    secret,
    refresh_token
  })

export const logOut = () => axios.delete("/api/v1/session")

export const requestMagicLink = ({ email, code }) => axios.post("/api/v2/magic_links", code ? { email, invite_link_code: code } : { email })

export const openIdLogIn = ({ accessToken }) => {
  const configurationStore = useConfigurationStore()
  return axios.post(`/api/v2/oidc_sessions/${configurationStore.configuration.openid.client_id}`, {
    access_token: accessToken
  })
}
